// extracted by mini-css-extract-plugin
export default {"Docs":"hCHhwZwwiwLZSxP0Zi2m","loading":"X_HyFySV88_r7JC1sL4p"};